import axios from 'axios'

const cache = new Map()

export const fetchPendingTasks = (identity) => {
  const existing = cache.get(identity)
  if (existing?.promise) return existing.promise
  if (existing?.data && Date.now() - existing.at < 30000) return Promise.resolve(existing.data)
  const promise = axios.get('/api/v2/admins/inbound_journey/products/pending_tasks').then(({ data }) => {
    cache.set(identity, { data, at: Date.now() })
    window.dispatchEvent(new CustomEvent('pending-tasks-refreshed', { detail: { identity, data } }))
    return data
  }).catch((error) => { cache.delete(identity); throw error })
  cache.set(identity, { promise })
  return promise
}
